import gql from 'graphql-tag';

export const mutationUnsubscribeDokkioUser = gql`
  mutation unsubscribeDokkioUser (
    $accountID: DokkioID!
    $email: String!
    $verificationHash: String!
  ) {
    unsubscribeDokkioUser (
      accountID: $accountID
      email: $email
      verificationHash: $verificationHash
    )
  }
`;
export default mutationUnsubscribeDokkioUser;
